import { render, staticRenderFns } from "./perfilPanel.vue?vue&type=template&id=48d84569&scoped=true"
import script from "./perfilPanel.vue?vue&type=script&lang=js"
export * from "./perfilPanel.vue?vue&type=script&lang=js"
import style0 from "./perfilPanel.vue?vue&type=style&index=0&id=48d84569&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d84569",
  null
  
)

export default component.exports